'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GoogleMapSmall = require('./GoogleMapSmall.scss');

var _GoogleMapSmall2 = _interopRequireDefault(_GoogleMapSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var googleBaseUrl = 'https://maps.googleapis.com/maps/api/staticmap';

var GoogleMapSmall = function (_Component) {
    (0, _inherits3.default)(GoogleMapSmall, _Component);

    function GoogleMapSmall() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, GoogleMapSmall);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GoogleMapSmall.__proto__ || (0, _getPrototypeOf2.default)(GoogleMapSmall)).call.apply(_ref, [this].concat(args))), _this), _this.getEncodedLocation = function (seller) {
            var location = ['' + seller.address, '' + seller.city, '' + seller.stateCode, '' + seller.zip, '' + seller.country];
            return encodeURIComponent(location.join(' '));
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(GoogleMapSmall, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['googleApiKey']) || (0, _propsComparer2.default)(this.props.seller, nextProps.seller, ['address', 'city', 'stateCode', 'zip', 'country']);
        }
    }, {
        key: 'render',
        value: function render() {
            var encodedLocation = this.getEncodedLocation(this.props.seller);
            var mapParams = ['key=' + this.props.googleApiKey, 'size=238x170', 'center=' + encodedLocation, 'zoom=13', 'scale=2', 'maptype=roadmap', 'format=png', 'visual_refresh=true', 'markers=size:mid%7Ccolor:0xff0000%7Clabel:%7C' + encodedLocation, 'style=feature:poi%7Cvisibility:off'];

            var mapTileSrc = googleBaseUrl + '?' + mapParams.join('&');

            return (0, _jsx3.default)('a', {
                href: 'https://www.google.com/maps/place/' + encodedLocation,
                target: '_blank'
            }, void 0, (0, _jsx3.default)('img', {
                className: _GoogleMapSmall2.default.map,
                src: mapTileSrc,
                alt: 'map'
            }));
        }
    }]);
    return GoogleMapSmall;
}(_react.Component);

exports.default = GoogleMapSmall;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GoogleMap/GoogleMapSmall.js
// module id = HlCz
// module chunks = 46